import { createAction, props } from '@ngrx/store';

import { KeyImage } from '../services/imaging/common';
import { ISeSideExaminationStudy } from '../se-side/se-side-components/se-side-key-images-container/se-side-key-images-models';

export const seReportNullAction = createAction('[SeReport] NullAction');

export const seReportApproveCompleted = createAction(
    '[SeReport] ApproveCompleted',
    props<{ error?: boolean; modules: string[]; print?: boolean }>(),
);

export const seReportSignCompleted = createAction(
    '[SeReport] SignCompleted',
    props<{ error?: boolean; modules: string[]; print ?: boolean }>(),
);

export const seReportSave = createAction('[SeReport] Save');

export const seReportSaveCompleted = createAction('[SeReport] SaveCompleted', props<{ error: boolean }>());

export const seReportSetIsModified = createAction('[SeReport] SetIsModified', props<{ isModified: boolean }>());

export const seReportSetIsPreview = createAction('[SeReport] SetIsPreview', props<{ isPreview: boolean }>());

export const seReportSetIsReadonly = createAction('[SeReport] SetIsReadonly', props<{ isReadonly: boolean }>());

export const seReportSetPatientId = createAction('[SeReport] SetPatientId', props<{ patientId: string | null }>());

export const seReportDeleteKeyImages = createAction('[SeReport] DeleteKeyImages', props<{ keyImages: KeyImage[] }>());

export const seReportSetKeyImages = createAction('[SeReport] SetKeyImages', props<{ keyImages: KeyImage[] }>());

export const seReportAddKeyImages = createAction('[SeReport] AddKeyImages', props<{ keyImages: KeyImage[] }>());

export const seReportSetImagesPerRowInPlaceholder = createAction(
    '[SeReport] SetImagesPerRowInPlaceholder',
    props<{ imagesPerRowInPlaceholder: number }>(),
);

export const seReportSetCurrentExaminationIdsEcg = createAction(
    '[SeReport] SetCurrentExaminationIdsEcg',
    props<{ ids: string[] }>(),
);

export const seReportSetCurrentExaminationIdsVisit = createAction(
    '[SeReport] SetCurrentExaminationIdsVisit',
    props<{ ids: string[] }>(),
);

export const seReportApplyNormalValues = createAction('[SeReport] ApplyNormalValues');

export const seReportImportConclusions = createAction('[SeReport] ImportConclusions', props<{ conclusions : string }>());

export const seReportSetExaminationStudies = createAction(
    '[SeReport] SetExaminationStudies',
    props<{ examinationStudies: ISeSideExaminationStudy[] }>(),
);
